import { io } from 'socket.io-client';

const socket = io(`${process.env.REACT_APP_API_SOCKET_URL}`, {
  autoConnect: false, // Auto-connect disabled to allow manual connection
  transports: ["websocket"], // Use WebSocket transport explicitly
});

export default socket;
